<template>
  <div class="chart_box" :id="randomId">
    <!-- 节点类型遍历start -->
<!--    <div :style="styleVal" style="display: flex;flex-wrap: wrap;padding: 10px;">-->
<!--      <div v-for="(item,index) in nodeConfigsMap" style="width: 200px;height: 100px;border:1px flex-shrink: 0;flex-grow: 0;margin: 0 30px 30px 0;padding: 10px;border: 1px solid black;    display: flex;-->
<!--          flex-direction: column;">-->
<!--        <div>{{ index + ' & ' + item }}</div>-->
<!--        <div style="flex-grow: 1;flex-shrink: 1;">-->
<!--          <node-model :nodeObj="{nodeType:index}"></node-model>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 节点类型遍历end -->
    <div class="node_render" :style="styleVal" v-if="nodeData && nodeData.length > 0" @mousedown="handleMouseDown"
         @mouseup="handleMouseUp" @wheel="handerScale">
      <div class="node_row" v-for="(nodeDataRow,indexR) in nodeData" :key="indexR">
        <div class="node_col" v-for="(nodeDataCol,indexC) in nodeDataRow" :key="indexR + '' + indexC">
          <node-model :invoke="invoke" :nodeObj="nodeDataCol" :index="indexC" :scaleVal="scaleVal" :appRemRegId="appRemRegId"></node-model>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
import NodeModel from './NodeModel.vue'

export default {
  components: {NodeModel},
  props: {
    nodeData: Array,
    styleConfig: Object,
    pageId: String,
    appRemRegId:String,
    invoke:Function
  },
  computed: {
    styleVal() {
      return {
        '--content-max-width':this.styleConfig.content_max_w + 'px',
        '--box-height': this.styleConfig.box_h + 'px',
        '--box-wight': this.styleConfig.box_w + 'px',
        '--all-height': this.styleConfig.line_h * 2 + 'px',
        '--all-wight': this.styleConfig.line_w * 2 + Number(this.styleConfig.box_w) + 'px',
        '--line-width': this.clientIsFire ? '1.6px' : '1px',
        '--left-margin': this.clientIsFire ? '-1.6px' : '-1px'
      }
    }
  },
  watch: {
    nodeData: function (val) {
      if (val != null) {
        let height = this.nodeData.length * this.styleConfig.line_h * 2 + 70 + 'px';
        $("#" + this.pageId + "[data-form-id='soecadm_flowconfirm_bill']").css({'height': height});
      }
      this.setFlow();
    }
  },
  data() {
    return {
      randomId: null,
      minScaleVal:1,
      maxScaleval:1.2,
      scaleVal:1,
      clientIsFire:false
    }
  },
  mounted() {
    if(navigator.userAgent.indexOf('Firefox') !== -1){
      this.clientIsFire = true;
    }
    this.randomId = "chart_box" + Math.floor(Math.random() * 10000);
    let flexPanals = $("div[id='flexpanalprocess']");
    let $flexPanal = $(flexPanals[flexPanals.length - 1]);
    $flexPanal.mouseleave(function (){
      document.onmousemove = document.onmouseup = null;
    })
    // 监听页面的mouseleave事件，当鼠标移出浏览器页面可用区域 并 松开按键时，停止拖动
    document.addEventListener("mouseleave", (e) => {
      document.onmousemove = document.onmouseup = null;
    });
  },
  methods: {
    setFlow(){
      setTimeout(() => {
        console.log(this.nodeData, this.styleConfig)
        console.log(this.pageId);
        let height = this.nodeData.length * this.styleConfig.line_h * 2 + 70 + 'px';
        // let width = this.nodeData[0].length*(this.styleConfig.line_w * 2 + Number(this.styleConfig.box_w)) + 'px';
        // let KdBoxW = $(this.pageId + " [data-form-id='soecadm_flowconfirm_bill']");
        $("#" + this.pageId + "[data-form-id='soecadm_flowconfirm_bill']").css({'height': height});
        console.log(this.nodeData.length * this.styleConfig.line_h * 2 + 'px')
        if(this.styleConfig.scale && this.styleConfig.scale === '1'){
          let flexPanals = $("div[id='flexpanalprocess']");
          let $flexPanal = $(flexPanals[flexPanals.length - 1]);
          let packW = $flexPanal.width();
          let packH = $flexPanal.height();
          let boxW = $("#" + this.randomId).width();
          let boxH = $("#" + this.randomId).height();
          console.log(packW,packH,boxW,boxH);
          $("#" + this.randomId).css({'top':(packH-boxH)/2,'left':(packW-boxW)/2});
          if(boxW > packW || boxH > packH){
            this.minScaleVal = packW/boxW < packH/boxH ? packW/boxW : packH/boxH;
          }else {
            this.minScaleVal = 1;
          }
          $("#" + this.randomId).css("transform",`scale(${this.minScaleVal})`);
          this.scaleVal = this.minScaleVal;
        }
      }, 100)
    },
    handleMouseDown(e) {
      let box = document.getElementById(this.randomId);
      // e.pageX, e.pageY 是鼠标在页面上的坐标
      // box.offsetLeft, box.offsetTop 是元素相对于页面左上角的偏移位置
      // disx, disy 便是鼠标相对于元素左上角的偏移位置
      let disx = e.pageX - box.offsetLeft;
      let disy = e.pageY - box.offsetTop;
      // document.documentElement.clientWidth: 浏览器页面可用宽度
      // document.documentElement.clientHeight: 浏览器页面可用高度
      document.onmousemove = function (e) {       // 鼠标移动的时候计算元素的位置
        let x, y;
        // e.pageX - disx  鼠标在页面上的位置 - 鼠标在元素中的偏移位置  得到的是元素相对于页面左上角的偏移位置
        // if ((e.pageX - disx) > 0) {  // 元素相对于页面左上角的偏移位置 大于0时
        if ((e.pageX - disx) > document.documentElement.clientWidth - 60) {   // 元素相对于页面左上角的偏移位置 移出到页面以外（右侧）
          x = document.documentElement.clientWidth - 60;   // 60是元素自身的宽高
        } else {
          x = e.pageX - disx;
        }
        // } else {    // 元素移到到页面以外（左侧）
        //   x = 0;
        // }
        // if ((e.pageY - disy) > 0) {
        if ((e.pageY - disy) > document.documentElement.clientHeight - 60) {   // 元素移动到页面以外（底部）
          y = document.documentElement.clientHeight - 60;
        } else {
          y = e.pageY - disy;
        }
        // } else {        // 元素移动到页面以外（顶部）
        //   y = 0;
        // }
        box.style.left = x + 'px';
        box.style.top = y + 'px';
      }
    },
    // 释放鼠标按钮，将事件清空，否则始终会跟着鼠标移动
    handleMouseUp() {
      document.onmousemove = document.onmouseup = null;
    },
    handerScale(e) {
      if(this.styleConfig.scale && this.styleConfig.scale === '1'){
        let transform = $("#" + this.randomId).css("transform");
        let scaleVal;
        if (transform === 'none') {
          scaleVal = 1;
        } else {
          scaleVal = Number($("#" + this.randomId).css("transform").split(',')[3]);
        }
        if (e.deltaY > 0) {
          scaleVal = scaleVal <= this.minScaleVal ? this.minScaleVal : scaleVal - 0.1;
          console.log("鼠标向下滚动，图片缩小");
        } else {
          scaleVal = scaleVal >= this.maxScaleval ? this.maxScaleval : scaleVal + 0.1;
          console.log("鼠标向上滚动，图片放大");
        }
        $("#" + this.randomId).css("transform", `scale(${scaleVal})`);
        this.scaleVal = scaleVal;
      }
    }
  }
}
</script>
<style lang="less">
.chart_box {
  cursor: -webkit-grab;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    clear: both;
  }
}

.node_render {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 10px;

  .node_row {
    display: flex;
    flex-direction: row;

    .node_col {
      flex-grow: 0;
      flex-shrink: 0;
      width: var(--all-wight);
      height: var(--all-height);
      //max-width: 200px;
      //min-width: 150px;
      margin-left: var(--left-margin);
    }
  }
}
</style>